export const OutlineShaderFrag = () => {
    const shader = /* glsl */`
    precision highp float;
    uniform vec3 color;
    uniform vec3 outlineColor;
    uniform float thickness;
    varying vec2 vUv;
    void main() {
        float edgeDistX = min(vUv.x, 1.0 - vUv.x) * 2.0;
        float edgeDistY = min(vUv.y, 1.0 - vUv.y) * 2.0;
        float edgeDist = min(edgeDistX, edgeDistY);
        float alpha = smoothstep(thickness, thickness + 0.01, edgeDist);
        vec3 finalColor = (1.0 - alpha) * outlineColor + alpha * color;
        gl_FragColor = vec4(finalColor, 1);
    }
    `;
    return shader;
}

export const OutlineShaderVert = () => {
    const shader = /* glsl */`
    varying vec2 vUv;
    void main() {
        vUv = uv;
        gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
    `;
    return shader;
}
